const unsplash = (id, w = 1600) =>
    `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const HERO_IMAGES = {
    plan: unsplash("photo-1542621334-a254cf47733d", 1600),
    house3d: unsplash("photo-1657346088167-b982455bf29a", 1600),
    realistic: unsplash("photo-1628012209120-d9db7abf7eab", 1600),
};

export const IMG_STONE_DUSK = unsplash("photo-1788894499164-2df2512adaed");
export const IMG_PLAN_ELEVATION = unsplash("photo-1721244654394-36a7bc2da288");
export const IMG_PLAN_SPREAD = unsplash("photo-1762146828422-50a8bd416d3c");
export const IMG_MATERIALS = unsplash("photo-1595414440701-da000c40df9c", 1200);
export const IMG_DRAWINGS = unsplash("photo-1503387762-592deb58ef4e", 1200);
export const IMG_SITE = unsplash("photo-1541888946425-d81bb19240f5", 1200);
export const IMG_WHITE_HOUSE = unsplash("photo-1600585154340-be6161a56a0c", 1600);
export const IMG_BRICK_HOUSE = unsplash("photo-1495578942200-c5f5d2137def", 1600);
export const IMG_INTERIOR = unsplash("photo-1724582586529-62622e50c0b3", 1800);

export const HERO_TRUST = [
    {
        icon: "file-check",
        title: "VERIFIED DATA",
        copy: "Verified project and pricing information.",
    },
    {
        icon: "scan-search",
        title: "INTELLIGENT AI",
        copy: "Understands and interprets your plans.",
    },
    {
        icon: "map-pin",
        title: "BUILT FOR SA",
        copy: "Designed around South African residential construction.",
    },
];

export const SIDEBAR_ITEMS = [
    "Dashboard",
    "Projects",
    "Home Vision",
    "Costs & BOQ",
    "Materials",
    "Quote Analyzer",
    "Compliance",
    "Green Intelligence",
    "Professionals",
    "Documents",
    "Messages",
    "Settings",
];

export const VIEW_CHIPS = [
    "Front View",
    "Rear View",
    "Left View",
    "Right View",
    "Aerial View",
];

export const CHANGE_LOG = [
    {
        label: "Exterior Wall: White Plaster → Face Brick",
        value: "+R85,420",
        tone: "accent",
    },
    { label: "Roof: Charcoal Tile (No Change)", value: "R0" },
    { label: "Windows: Black Aluminium (No Change)", value: "R0" },
];

export const WORKFLOW = [
    { n: "01", title: "Plan", copy: "Upload your architectural plan.", icon: "FileUp" },
    { n: "02", title: "Understand", copy: "BuildEase interprets the information available.", icon: "FileSearch" },
    { n: "03", title: "Visualise", copy: "See an AI-generated concept of your home.", icon: "Layers" },
    { n: "04", title: "Explore", copy: "Move between exterior, interior and architectural views.", icon: "Orbit" },
    { n: "05", title: "Customise", copy: "Change finishes, materials and design choices.", icon: "PenTool" },
    { n: "06", title: "Price", copy: "Understand potential cost impact using verified pricing.", icon: "Calculator", active: true },
    { n: "07", title: "Verify", copy: "Separate documented facts from visualisations and assumptions.", icon: "ShieldCheck" },
    { n: "08", title: "Build", copy: "Carry that intelligence into construction.", icon: "Hammer" },
];

export const EXPLORATION_VIEWS = [
    { id: "exterior", label: "Exterior", img: HERO_IMAGES.house3d },
    { id: "interior", label: "Interior", img: IMG_INTERIOR },
    { id: "floor1", label: "Floor 1", img: IMG_PLAN_ELEVATION },
    { id: "floor2", label: "Floor 2", img: IMG_PLAN_SPREAD },
];

export const DESIGN_COST = {
    before: {
        tag: "BEFORE",
        finish: "EXTERIOR: WHITE PLASTER",
        img: IMG_WHITE_HOUSE,
        alt: "Contemporary home with a white plaster exterior",
    },
    after: {
        tag: "AFTER",
        finish: "EXTERIOR: FACE BRICK",
        img: IMG_BRICK_HOUSE,
        alt: "Concept of the same home with a face brick exterior",
    },
    analysis: [
        { label: "AFFECTED COMPONENT", value: "Exterior walls" },
        { label: "MATERIAL", value: "Face brick" },
        { label: "QUANTITY", value: "Verified project quantity" },
        { label: "LOCAL PRICING", value: "Verified supplier data" },
    ],
    impact: "+ R85,420",
};

export const MATERIALS_CARD = {
    product: "50kg Cement",
    location: "Durban, KwaZulu-Natal",
    supplier: "Verified Local Supplier",
    price: "R — / bag",
    status: "VERIFIED",
    stamp: "VERIFIED · 28 SEP 2026",
};

export const QUOTE_DOC = {
    contractor: "EXAMPLE CONTRACTOR (PTY) LTD",
    meta: "QUOTE NO. Q-2026-118 · VALID 30 DAYS",
    rows: [
        { item: "Cement", detail: "32 × 50kg bags", amount: "R18,400" },
        { item: "Face Brick", detail: "12,400 stock bricks", amount: "R42,150" },
        { item: "Windows", detail: "8 × aluminium units", amount: "R36,900" },
        { item: "Labour", detail: "Stage 2 — brickwork", amount: "R85,000" },
        { item: "Delivery", detail: "2 × mixer loads", amount: "R6,750" },
    ],
    total: "R189,200",
};

export const QUOTE_ANALYSIS = [
    { item: "Cement", state: "WITHIN OBSERVED RANGE", tone: "verified" },
    { item: "Face Brick", state: "WITHIN OBSERVED RANGE", tone: "verified" },
    { item: "Windows", state: "PRICE REQUIRES REVIEW", tone: "review" },
    { item: "Labour", state: "SPECIFICATION REVIEW", tone: "spec" },
    { item: "Delivery", state: "WITHIN OBSERVED RANGE", tone: "verified" },
];

export const PRODUCT_CARDS = [
    {
        id: "home-vision",
        title: "Home Vision",
        status: "VISUALISED",
        tone: "visualised",
        image: IMG_STONE_DUSK,
        alt: "Contemporary stone-clad South African home at dusk",
        copy: "See your home before you build it.",
        href: "/home-vision",
    },
    {
        id: "costs-boq",
        title: "Costs & BOQ",
        status: "VERIFIED",
        tone: "verified",
        image: IMG_PLAN_ELEVATION,
        alt: "Architectural elevation drawing of a residence",
        copy: "Understand the project's expected cost structure.",
        href: "/pricing",
    },
    {
        id: "materials",
        title: "Materials Intelligence",
        status: "VERIFIED",
        tone: "verified",
        image: IMG_MATERIALS,
        alt: "Construction material palette of brick, timber and steel",
        copy: "Access relevant verified material pricing.",
        href: "/materials-intelligence",
    },
    {
        id: "quote-analyzer",
        title: "Quote Analyzer",
        status: "ANALYSED",
        tone: "analysis",
        image: IMG_DRAWINGS,
        alt: "Architectural drawings laid out for review",
        copy: "Understand contractor and supplier quotes.",
        href: "/how-it-works",
    },
    {
        id: "construction-intelligence",
        title: "Construction Intelligence",
        status: "SUPPORTED",
        tone: "supported",
        image: IMG_SITE,
        alt: "Residential construction site environment with scaffolding",
        copy: "Compliance, sustainability, professionals, documents and project management.",
        href: "/for-professionals",
    },
];

export const TRUST_STATES = [
    {
        id: "verified",
        label: "VERIFIED",
        tone: "verified",
        icon: "FileCheck",
        copy: "Supported by project documentation, verified data or an appropriate source.",
    },
    {
        id: "visualised",
        label: "VISUALISED",
        tone: "visualised",
        icon: "Eye",
        copy: "AI-generated interpretation intended to help you understand the design.",
    },
    {
        id: "assumed",
        label: "ASSUMED",
        tone: "assumed",
        icon: "HelpCircle",
        copy: "An inference made because information isn't available.",
    },
];

export const ECOSYSTEM_NODES = [
    { id: "N.01", slug: "home-vision", label: "HOME VISION", x: 16, y: 10 },
    { id: "N.02", slug: "costs-boq", label: "COSTS & BOQ", x: 50, y: 6 },
    { id: "N.03", slug: "materials", label: "MATERIALS INTELLIGENCE", x: 84, y: 10 },
    { id: "N.04", slug: "quote-analyzer", label: "QUOTE ANALYZER", x: 8, y: 47 },
    { id: "N.05", slug: "compliance", label: "COMPLIANCE", x: 92, y: 47 },
    { id: "N.06", slug: "green-intelligence", label: "GREEN INTELLIGENCE", x: 12, y: 84, tone: "green" },
    { id: "N.07", slug: "professionals", label: "PROFESSIONALS", x: 36, y: 94 },
    { id: "N.08", slug: "documents", label: "DOCUMENTS", x: 64, y: 94 },
    { id: "N.09", slug: "project-management", label: "PROJECT MANAGEMENT", x: 88, y: 84 },
];
